// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"3b55ae84","162":"754e251b","184":"651c0c51","188":"e94a6b5e","200":"05f32773","237":"65b94dcd","383":"a7d8df3f","444":"e784aa8a","523":"ab9dcef4","569":"9bb44c03","609":"d526bae9","779":"49b70847","822":"fad66c4c","852":"96896079","987":"4efd70f9"}[chunkId] + ".chunk.js";
};